import { render, staticRenderFns } from "./plain.vue?vue&type=template&id=28f99c56"
import script from "./plain.vue?vue&type=script&lang=js"
export * from "./plain.vue?vue&type=script&lang=js"
import style0 from "./layout.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports